import axios, { AxiosRequestConfig } from 'axios';
import { PublicSitter } from '../types/PublicSitter';
import { DataResponse } from '../types/api';

const URL = '/v2/public/sitters';

class PublicSitterService {
  static getByFilter(config?: AxiosRequestConfig):
    Promise<DataResponse<PublicSitter>> {
    return axios.get(URL, config);
  }
}

export { PublicSitterService }
